export const META_APP_ID = "1381357453683652";
export const META_APP_SECRET = "13f2857cf5daa94f16dfb05cc51c7da6";
